export * from './lib/interfaces/mobile-phone-form-field-config.interface';
export * from './lib/form-mobile-phone.module';
